module.exports = __webpack_public_path__ + "img/chevron-up.84021b81.svg";